import type { DateRange } from "react-day-picker"

export const formatCompactDate = (dateOrDateString: string | Date) => {
	const date = dateOrDateString instanceof Date ? dateOrDateString : new Date(dateOrDateString)
	return date.toLocaleDateString()
}

export const formatTimestampDate = (dateOrDateString: string | Date) => {
	const date = dateOrDateString instanceof Date ? dateOrDateString : new Date(dateOrDateString)
	return date.toLocaleString(undefined, {
		month: "long",
		day: "numeric",
		year: "numeric",
	})
}

export const formatDateRange = (dateRange: DateRange) => {
	return `${dateRange.from?.toLocaleDateString()} - ${dateRange.to?.toLocaleDateString()}`
}

export function getWeekDateRange(): DateRange {
	const today = new Date()
	const oneWeekAgo = new Date()
	oneWeekAgo.setDate(today.getDate() - 7)
	return { from: oneWeekAgo, to: today }
}

export const isDateInRange = (dateOrDateString: string | Date, dateRange: DateRange | undefined) => {
	if (!dateRange) return true

	const date = dateOrDateString instanceof Date ? dateOrDateString : new Date(dateOrDateString)

	if (dateRange.from) {
		const fromDate = new Date(dateRange.from)
		fromDate.setHours(0, 0, 0, 0)
		if (date < fromDate) return false
	}

	if (dateRange.to) {
		const toDate = new Date(dateRange.to)
		toDate.setHours(23, 59, 59, 999)
		if (date > toDate) return false
	}

	return true
}
